export const CREATE_LIST_PROPERTY = "CREATE_LIST_PROPERTY";
export const CREATE_LIST_PROPERTY_FAILURE = "CREATE_LIST_PROPERTY_FAILURE";
export const CREATE_LIST_PROPERTY_SUCCESS = "CREATE_LIST_PROPERTY_SUCCESS";

 
